import type { SITE_ACQUISITION_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-acquisition-card/site-acquisition-card.fr.ts";

export const SITE_ACQUISITION_CARD_ENGLISH_LOCALE = {
  title: "Acquisition",
  subtitle: "Last 7 days",
  state: {
    BAD: "Bad",
    MEDIUM: "Medium",
    GOOD: "Good",
  },
} satisfies typeof SITE_ACQUISITION_CARD_FRENCH_LOCALE;
